import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import Tag from "components/Tag/Tag";

const RemovableTagLabel = (props: RemovableProps<server.dto.TagForList>) => {
  return <RemovableLabel {...props}>
    <Tag
      key={props.value.tagId}
      title={props.value.title}
      label={props.value.title}
      color={props.value.hexColor}
    />
  </RemovableLabel>;
};

export default RemovableTagLabel;